import ResearchTable from "@/components/ResearchTable";
import usePageTitle from "@/lib/usePageTitle";

export default function ResearchPage() {
  usePageTitle("Research Hub");
  return <ResearchTable />;
}
